import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectAccountRolesRetrieval = createSelector(
  [(state: AppState) => state.shared.accountRolesRetrieval],
  ({ data, fetching }) => ({
    data,
    fetching,
  }),
);
